import { RouterPathes } from './router-paths'

export const PAGE_TITLE_BY_ROUTE_MAP: { [key: string]: string } = {
  [RouterPathes.oneVsOne]: '1vs1',
  [RouterPathes.setups]: 'Setups',
  [RouterPathes.bullsEye]: "Bull's eye",
  [RouterPathes.upDown]: 'Up/Down',
  [RouterPathes.memeWars]: 'Meme wars',
  [RouterPathes.priceFormulation]: 'Price formulation',
  [RouterPathes.fundingPayments]: 'Funding payments',
  [RouterPathes.settings]: 'Settings',
  [RouterPathes.profile]: 'Profile',
  [RouterPathes.notifications]: 'Notifications',
  [RouterPathes.passwordRecovery]: 'Password recovery',
  [RouterPathes.rewards]: 'Rewards',
  [RouterPathes.help]: 'Help',
  [RouterPathes.onboarding]: 'Onboarding',
  [RouterPathes.onboardingBullsEye]: 'Onboarding',
  [RouterPathes.onboardingOneVsOne]: 'Onboarding',
  [RouterPathes.onboardingReferralProgram]: 'Onboarding',
  [RouterPathes.onboardingRewardsSystem]: 'Onboarding',
  [RouterPathes.onboardingSetups]: 'Onboarding',
  [RouterPathes.onboardingTreasure]: 'Onboarding',
  [RouterPathes.onboardingUpDown]: 'Onboarding',
  [RouterPathes.onboardingMemeWars]: 'Onboarding',
  [RouterPathes.termsAndConditions]: 'Terms and Conditions',
  [RouterPathes.privacyPolicy]: 'Privacy Policy',
  [RouterPathes.termsOfService]: 'Terms of Service',
  [RouterPathes.amlPolicy]: 'AML policy',
  [RouterPathes.oAuth]: 'Auth',
  [RouterPathes.unlogged]: 'Unlogged',
  [RouterPathes.about]: 'About',
  [RouterPathes.referrals]: 'Referrals',
  [RouterPathes.home]: 'Home'
}
